import { call, put } from "redux-saga/effects";
import { Request } from "../api/mobile-frame/MobileFrame.api";
import {
  setEklokData,
  setManualCommandList,
  setSoundBlockLevel,
} from "../store/data/common-data.store";
import {
  getMobileFrameData,
  getMobileFrameDataError,
  getMobileFrameDataSuccess,
} from "../store/mobile-frame-home-page.store";
import {
  getCommandListPageData,
  getCommandListPageDataError,
  getCommandListPageDataSuccess,
} from "../store/command-list-page.store";
import {
  getCommandDetailPageData,
  getCommandDetailPageDataError,
  getCommandDetailPageDataSuccess,
  getEventStatusListData,
} from "../store/command-detail-page.store";
import {
  getEventStatusListPageData,
  getEventStatusListPageDataError,
  getEventStatusListPageDataSuccess,
  stopAction,
  stopActionError,
  stopAllActionError,
} from "../store/event-status-list-page.store";
import {
  getBlocksSoundsData,
  getBlocksSoundsDataError,
  getBlocksSoundsDataSuccess,
} from "../store/blocks-sounds-page.store";
import {
  getAssistanceDataError,
  getAssistanceDataSuccess,
} from "../store/assistance-page.store";
import {
  calendarEventDataError,
  getCalendarEventDataSuccess,
  deleteCalendarEventDataSuccess,
} from "../store/calendar-event-page.store";
import {
  addCalendarEventDataSuccess,
  addCalendarEventDataError,
} from "../store/add-calendar-event-page.store";
import {
  setConnectionLineStatusError,
  successConnectionLineStatus,
} from "../store/eklok-line-status.store";

export function* mobileFrameDataSaga(action) {
  try {
    const eklokDataResponse = yield call(
      Request.eklok,
      action.payload.token.access,
      action.payload.eklok,
    );
    yield put(setEklokData(eklokDataResponse));
    if (action.type !== getMobileFrameData.type) {
      const commandListResponse = yield call(
        Request.commandList,
        action.payload.token.access,
        action.payload.eklok,
      );
      yield put(setManualCommandList(commandListResponse));
    }
    switch (action.type) {
      case getMobileFrameData.type: {
        const getSoundBlockStatusResponse = yield call(
          Request.getSoundBlockStatus,
          action.payload.token.access,
          action.payload.eklok,
        );
        yield put(
          setSoundBlockLevel(
            getSoundBlockStatusResponse.data.data.SOUND_BLOCK_LEVEL,
          ),
        );
        yield put(getMobileFrameDataSuccess());
        break;
      }
      case getCommandListPageData.type: {
        yield put(getCommandListPageDataSuccess());
        break;
      }
      case getCommandDetailPageData.type: {
        yield put(getEventStatusListData(action.payload));
        break;
      }
      default:
        break;
    }
  } catch (e) {
    switch (action.type) {
      case getMobileFrameData.type: {
        yield put(getMobileFrameDataError(e));
        break;
      }
      case getCommandListPageData.type: {
        yield put(getCommandListPageDataError(e));
        break;
      }
      case getCommandDetailPageData.type: {
        yield put(getCommandDetailPageDataError(e));
        break;
      }
      default:
        break;
    }
  }
}

export function* eventStatusListDataSaga(action) {
  console.log(action);
  try {
    const eventStatusListResponse = yield call(
      Request.eventStatusList,
      action.payload.token.access,
      action.payload.eklok,
    );
    action.type === getEventStatusListPageData.type
      ? yield put(getEventStatusListPageDataSuccess(eventStatusListResponse))
      : yield put(getCommandDetailPageDataSuccess(eventStatusListResponse));
  } catch (e) {
    action.type === getEventStatusListPageData.type
      ? yield put(getEventStatusListPageDataError(e))
      : yield put(getCommandDetailPageDataError(e));
  }
}

export function* stopAllActionEventSaga(action) {
  try {
    yield call(Request.stopAllActionEvent, action.payload.token.access, {
      eklok: action.payload.eklok,
    });
    yield put(getEventStatusListPageData(action.payload));
  } catch (e) {
    console.log("stopAllActionEventSaga", e);
    yield put(stopAllActionError(e));
  }
}

export function* setActionEventSaga(action) {
  try {
    yield call(Request.setActionEvent, action.payload.token.access, {
      eklok: action.payload.eklok,
      cmd_id: action.payload.actionId,
      cmd_type: action.payload.actionType,
      cmd_status: action.payload.cmd,
    });
    action.type === stopAction.type
      ? yield put(getEventStatusListPageData(action.payload))
      : yield put(getEventStatusListData(action.payload));
  } catch (e) {
    console.log("setActionEventSaga", e);
    action.type === stopAction.type
      ? yield put(stopActionError(e))
      : yield put(getCommandDetailPageDataError(e));
  }
}

export function* blocksSoundsDataSaga(action) {
  try {
    const eklokDataResponse = yield call(
      Request.eklok,
      action.payload.token.access,
      action.payload.eklok,
    );
    yield put(setEklokData(eklokDataResponse));
    const getSoundBlockStatusResponse = yield call(
      Request.getSoundBlockStatus,
      action.payload.token.access,
      action.payload.eklok,
    );
    yield put(
      setSoundBlockLevel(
        getSoundBlockStatusResponse.data.data.SOUND_BLOCK_LEVEL,
      ),
    );
    yield put(getBlocksSoundsDataSuccess());
  } catch (e) {
    yield put(getBlocksSoundsDataError(e));
  }
}

export function* setBlocksSoundsLevelSaga(action) {
  try {
    yield call(Request.setSoundBlockStatus, action.payload.token.access, {
      eklok: action.payload.eklok,
      sound_block_level: action.payload.soundBlockLevel,
    });
    yield put(getBlocksSoundsData(action.payload));
  } catch (e) {
    console.log("setBlocksSoundsLevelSaga", e);
    yield put(getBlocksSoundsDataError(e));
  }
}

export function* assistanceDataSaga(action) {
  try {
    const eklokDataResponse = yield call(
      Request.eklok,
      action.payload.token.access,
      action.payload.eklok,
    );
    yield put(setEklokData(eklokDataResponse));
    const assistanceDataResponse = yield call(
      Request.assistanceData,
      action.payload.token.access,
      action.payload.eklok,
    );
    yield put(getAssistanceDataSuccess(assistanceDataResponse.data.data));
  } catch (e) {
    yield put(getAssistanceDataError(e));
  }
}

export function* calendarEventDataSaga(action) {
  try {
    const calendarEventDataResponse = yield call(
      Request.calendarEventData,
      action.payload.token.access,
      action.payload.body,
    );
    yield put(getCalendarEventDataSuccess(calendarEventDataResponse));
  } catch (e) {
    yield put(calendarEventDataError(e));
  }
}

export function* deleteCalendarEventDataSaga(action) {
  try {
    const deleteCalendarEventDataResponse = yield call(
      Request.deleteCalendarEventData,
      action.payload.token.access,
      action.payload.body,
    );
    yield put(deleteCalendarEventDataSuccess(deleteCalendarEventDataResponse));
  } catch (e) {
    yield put(calendarEventDataError(e));
  }
}

export function* addCalendarEventDataSaga(action) {
  try {
    const addCalendarEventDataResponse = yield call(
      Request.addCalendarEventData,
      action.payload.token.access,
      action.payload.body,
    );
    yield put(addCalendarEventDataSuccess(addCalendarEventDataResponse));
  } catch (e) {
    yield put(addCalendarEventDataError(e));
  }
}

export function* setEklokLineStatusSaga(action) {
  try {
    const apiBody = {
      eklok: action.payload.body.eklok,
      line_status: action.payload.body.line_status,
    };
    yield call(
      Request.setEklokLineStatus,
      action.payload.token.access,
      apiBody,
    );
    yield put(successConnectionLineStatus(action.payload));
  } catch (e) {
    yield put(setConnectionLineStatusError(e));
  }
}
